import type { AttachmentCompactProps } from "./components/AttachmentCompactView";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "AttachmentsCompact"*/ "./lazyIndex"), { name: "AttachmentsCompact" });

// Delayed Loaded Components
export const AttachmentCompactView: LazyComponent<AttachmentCompactProps, unknown, void> = createLazyComponent(lazyModule, m => m.AttachmentCompactView);

export { SpecialDocViewMode } from "./types/SpecialDocViewMode";
